// src/data/partyGearStores.js
import { FiShoppingBag, FiBookOpen, FiStar, FiZap } from "react-icons/fi";

/**
 * "JSON format, extracted from a JS file" ✅
 * (Pure objects; stored in a JS module so we *can* reference icons.)
 */
export const partyGearStores = [
    // --- Melbourne ---
    {
        country: "Australia",
        city: "Melbourne",
        name: "Daily Jocks Warehouse",
        description: "Sells male underwear and street wear.",
        address: "261 Chapel Street, Prahran 3181 (VIC)",
        website: "https://dailyjocks.com.au",
        category: "Underwear & Streetwear",
        icon: FiShoppingBag,
    },
    {
        country: "Australia",
        city: "Melbourne",
        name: "Hares & Hyenas",
        description:
            "LGBTQ+ books, zines, and some clothing/merch. A queer cultural institution — also hosts events",
        address: "63 Johnston St, Fitzroy (VIC)",
        website: "https://hares-hyenas.com.au",
        category: "Bookshop & Queer Hub",
        icon: FiBookOpen,
    },
    {
        country: "Australia",
        city: "Melbourne",
        name: "RetroStar Vintage",
        description: "Wide range of vintage and 90s/00s LGBTQ-style nostalgia",
        address: "1st Floor, Nicholas Building, 37 Swanston St, Melbourne (VIC)",
        website: "https://www.retrostar.com.au/",
        category: "Vintage Fashion",
        icon: FiStar,
    },
    {
        country: "Australia",
        city: "Melbourne",
        name: "Shag",
        description:
            "Retro, flamboyant, club-ready fashion. Known for bold pieces, perfect for queer self-expression",
        address: "84 Smith St, Collingwood VIC 3066 & 130 Chapel St, Windsor VIC 3181",
        website: "https://shagmelbourne.com/",
        category: "Fashion",
        icon: FiZap,
    },

    // --- Sydney ---
    {
        country: "Australia",
        city: "Sydney",
        name: "The Bookshop Darlinghurst",
        description:
            "A queer treasure trove tucked inside a beloved bookstore. From DVDs and books, magazines, it’s a one-stop shop celebrating and supporting the LGBTQ+ community.",
        address: "207 Oxford St, Sydney, NSW 2010",
        website: "https://www.thebookshop.com.au/",
        category: "Bookshop & Queer Hub",
        icon: FiZap,
    },
    {
        country: "Australia",
        city: "Sydney",
        name: "TEAMM8",
        description:
            "The flagship playground of a sizzling underwear and swimwear brand Find the perfect suit or barely-there number to complete the look.",
        address: "10/417-421 Bourke St, Surry Hills, NSW 2010",
        website: "https://www.teamm8.com/",
        category: "Fashion",
        icon: FiZap,
    },
    {
        country: "Australia",
        city: "Brisbane",
        name: "Shelf Lovers",
        description:
            "Shelf Lovers is an independent bookstore offering a unique and carefully curated collection of LGBTQ+ books and gifts. ",
        address: "Online Store based in Brisbane, QLD",
        website: "https://shelflovers.com.au/",
        category: "Bookshop",
        icon: FiZap,
    },
];
